var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "string-cell",
      class: [
        _vm.field.alignment,
        {
          "invalid-value": _vm.invalidValue,
          outlined: _vm.outlined,
          readonly: _vm.readonly,
        },
      ],
      on: {
        mouseenter: function ($event) {
          _vm.showOverlay = true
        },
        mouseleave: function ($event) {
          _vm.showOverlay = false
        },
      },
    },
    [
      !_vm.editing
        ? [
            _c("a-tooltip", { attrs: { title: _vm.value } }, [
              _c("div", { staticClass: "text-wrapper" }, [
                _vm._v(
                  "\n                " + _vm._s(_vm.value) + "\n            "
                ),
              ]),
            ]),
          ]
        : [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value,
                  expression: "value",
                },
              ],
              ref: "input",
              staticClass: "borderless-input",
              class: { "invalid-input": _vm.invalidValue },
              attrs: { type: "text" },
              domProps: { value: _vm.value },
              on: {
                blur: _vm.debouncedDisableEdit,
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.debouncedDisableEdit.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.value = $event.target.value
                },
              },
            }),
          ],
      _vm._v(" "),
      !_vm.editing && _vm.showOverlay && !_vm.readonly
        ? _c(
            "div",
            { staticClass: "overlay-actions" },
            [
              _vm.isUrlField && _vm.value
                ? _c("a-button", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticStyle: { "margin-right": "4px" },
                    attrs: {
                      icon: "link",
                      size: "small",
                      content: "URL'yi aç",
                    },
                    on: { click: _vm.openUrlInNewTab },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _vm.aiMode
                    ? _c("a-button", {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticStyle: { "margin-right": "4px" },
                        attrs: {
                          icon: "thunderbolt",
                          size: "small",
                          content: "Yapay Zeka'yı çalıştır",
                        },
                        on: { click: _vm.runAiField },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("a-button", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticStyle: { "margin-right": "4px" },
                    attrs: { icon: "edit", size: "small", content: "Düzenle" },
                    on: { click: _vm.enableEdit },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("a-button", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticStyle: { "margin-right": "4px" },
                    attrs: {
                      icon: "delete",
                      type: "danger",
                      size: "small",
                      content: "Sil",
                    },
                    on: { click: _vm.deleteValue },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isEmailField
                ? _c("a-button", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticStyle: { "margin-right": "4px" },
                    attrs: {
                      icon: "mail",
                      size: "small",
                      content: "E-posta gönder",
                    },
                    on: { click: _vm.openMailComposerModal },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isPhoneField
                ? _c(
                    "a-button",
                    {
                      staticClass: "whatsapp-button",
                      attrs: { size: "small" },
                      on: { click: _vm.openWhatsappModal },
                    },
                    [_c("WhatsappIcon")],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("whatsappChatStart"),
                showFooter: false,
                className: "whatsapp-chat-starter-modal keydown-prevent-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.value,
                  "channel-override": "",
                  "phone-number-override": "",
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMailComposerModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("mail.composeNewEmail"),
                showFooter: false,
                xlarge: "",
                className: "table-mail-composer-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.showMailComposerModal = false
                },
              },
            },
            [
              _c("MailCompose", {
                attrs: {
                  "show-header": false,
                  "mail-data": _vm.mailComposerData,
                  "enabled-select-sender": true,
                  "selected-email-id": _vm.defaultMailId,
                },
                on: {
                  close: function ($event) {
                    _vm.showMailComposerModal = false
                  },
                  sent: function ($event) {
                    _vm.showMailComposerModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }